/* jshint esversion: 6 */

// API transmission states
export const STATE_TXRX = 'STATE_TXRX';
export const STATE_SUCCESS = 'STATE_SUCCESS';
export const STATE_ERROR = 'STATE_ERROR';

// App actions
export const APP_LOADING = 'APP_LOADING';
export const APP_READY = 'APP_READY';
export const API_ERROR = 'API_ERROR';
export const API_ERROR_DELETE = 'API_ERROR_DELETE';
export const APP_ERROR_SET = 'APP_ERROR_SET';
export const APP_ERROR_DELETE = 'APP_ERROR_DELETE';
export const APP_LOGIN_USER = 'APP_LOGIN_USER';
export const APP_CREATE_USER = 'APP_CREATE_USER';
export const APP_AUTOLOGIN = 'APP_AUTOLOGIN';
export const APP_CHECK_USER = 'APP_CHECK_USER';
export const APP_MESSAGES_CREATE = 'APP_MESSAGES_CREATE';
export const APP_MESSAGES_DELETE = 'APP_MESSAGES_DELETE';
export const APP_SET_USER_SESSION = 'APP_SET_USER_SESSION';

// User actions
export const USER_FETCH = 'USER_FETCH';
export const USER_FETCH_PERMS = 'USER_FETCH_PERMS';
export const USER_UPDATE = 'USER_UPDATE';
export const USER_DELETE = 'USER_DELETE';
export const USER_GENERATE_API_KEY = 'USER_GENERATE_API_KEY';
export const USER_FETCH_PLAN = 'USER_FETCH_PLAN';
export const USER_DETACH_CLIENT = 'USER_DETACH_CLIENT';

// Subscription actions
export const SUB_FETCH = 'SUB_FETCH';
export const SUB_FETCH_DETAIL = 'SUB_FETCH_DETAIL';
export const SUB_CREATE = 'SUB_CREATE';
export const SUB_ADDON_UPDATE = 'SUB_ADDON_UPDATE';
export const SUB_UPDATE = 'SUB_UPDATE';
export const SUB_LIMIT_CHECK = 'SUB_LIMIT_CHECK';
export const SUB_FETCH_PLANS = 'SUB_FETCH_PLANS';
export const SUB_FETCH_INVOICES = 'SUB_FETCH_INVOICES';
export const SUB_FETCH_INVOICE = 'SUB_FETCH_INVOICE';
export const SUB_FETCH_BILLING = 'SUB_FETCH_BILLING';
export const SUB_UPDATE_BILLING = 'SUB_UPDATE_BILLING';
export const SUB_UPDATE_PULL_FREQ = 'SUB_UPDATE_PULL_FREQ';
export const SUB_VALIDATE_COUPON = 'SUB_VALIDATE_COUPON';
export const SUB_RESET_COUPON = 'SUB_RESET_COUPON';
export const SUB_VALIDATE_PROMO = 'SUB_VALIDATE_PROMO';
export const SUB_REDEEM_PROMO = 'SUB_REDEEM_PROMO';
export const SUB_PAUSE_SUBSCRIPTION = 'SUB_PAUSE_SUBSCRIPTION';
export const SUB_APPLY_COUPON = 'SUB_APPLY_COUPON';

// Login actions
export const SOCIAL_LOGIN_CREATE = 'SOCIAL_LOGIN_CREATE';
export const SOCIAL_LOGIN_DELETE = 'SOCIAL_LOGIN_DELETE';
export const SOCIAL_LOGIN_LIST = 'SOCIAL_LOGIN_LIST';

// Route Actions
export const ROUTE_LIST = 'ROUTE_LIST';
export const ROUTE_SHOW = 'ROUTE_SHOW';
export const ROUTE_CREATE = 'ROUTE_CREATE';
export const ROUTE_UPDATE = 'ROUTE_UPDATE';
export const ROUTE_DELETE = 'ROUTE_DELETE';

// Input Actions
export const INPUT_LIST = 'INPUT_LIST';
export const INPUT_SHOW = 'INPUT_SHOW';
export const INPUT_CREATE = 'INPUT_CREATE';
export const INPUT_UPDATE = 'INPUT_UPDATE';
export const INPUT_DELETE = 'INPUT_DELETE';
export const INPUT_VALIDATE = 'INPUT_VALIDATE';
export const INPUT_CLEAR_VALIDATION = 'INPUT_CLEAR_VALIDATION';
export const INPUT_LOG = 'INPUT_LOG';
export const INPUT_REFRESH = 'INPUT_REFRESH';
export const INPUT_REAUTH = 'INPUT_REAUTH';
export const INPUT_LIST_SOCIAL_CREDS = 'INPUT_LIST_SOCIAL_CREDS';

// Output Actions
export const OUTPUT_LIST = 'OUTPUT_LIST';
export const OUTPUT_SHOW = 'OUTPUT_SHOW';
export const OUTPUT_CREATE = 'OUTPUT_CREATE';
export const OUTPUT_UPDATE = 'OUTPUT_UPDATE';
export const OUTPUT_DELETE = 'OUTPUT_DELETE';

// Social Actions
export const SOCIAL_LIST = 'SOCIAL_LIST';
export const SOCIAL_SHOW = 'SOCIAL_SHOW';
export const SOCIAL_CREATE = 'SOCIAL_CREATE';
export const SOCIAL_CREATE_BATCH = 'SOCIAL_CREATE_BATCH';
export const SOCIAL_BATCH_POLL = 'SOCIAL_BATCH_POLL';
export const SOCIAL_UPDATE = 'SOCIAL_UPDATE';
export const SOCIAL_DELETE = 'SOCIAL_DELETE';
export const SOCIAL_LOG = 'SOCIAL_LOG';
export const SOCIAL_CHECK_AUTH = 'SOCIAL_CHECK_AUTH';
export const SOCIAL_TYPE_LIST = 'SOCIAL_TYPE_LIST';
export const SOCIAL_TYPE_DEFAULTS = 'SOCIAL_TYPE_DEFAULTS';
export const SOCIAL_QUEUE_COUNT = 'SOCIAL_QUEUE_COUNT';
export const SOCIAL_REAUTH = 'SOCIAL_REAUTH';
export const SOCIAL_GET_FB_GROUP_STATUS = 'SOCIAL_GET_FB_GROUP_STATUS';
export const SOCIAL_GET_CATEGORIES = 'SOCIAL_GET_CATEGORIES'; // youtube only at this point
export const SOCIAL_GET_PLAYLISTS = 'SOCIAL_GET_PLAYLISTS';
export const SOCIAL_GET_POST_ANALYTICS = 'SOCIAL_GET_POST_ANALYTICS';

// Curation Actions
export const CURATION_ID = 'CURATION_ID';
export const CURATION_LIST = 'CURATION_LIST';
export const CURATION_SHOW = 'CURATION_SHOW';
export const CURATION_DELETE = 'CURATION_DELETE';
export const CURATION_COUNT = 'CURATION_COUNT';
export const CURATION_ROUTE_CREATE = 'CURATION_ROUTE_CREATE';
export const CURATION_INPUT_SHOW = 'CURATION_INPUT_SHOW';
export const CURATION_INPUT_UPDATE = 'CURATION_INPUT_UPDATE';
export const CURATION_INPUT_DELETE = 'CURATION_INPUT_DELETE';
export const CURATION_INPUT_CREATE = 'CURATION_INPUT_CREATE';
export const CURATION_INPUT_LOG = 'CURATION_INPUT_LOG';

// Domain actions
export const DOMAIN_LIST = 'DOMAIN_LIST';
export const DOMAIN_SHOW = 'DOMAIN_SHOW';
export const DOMAIN_CREATE = 'DOMAIN_CREATE';
export const DOMAIN_UPDATE = 'DOMAIN_UPDATE';
export const DOMAIN_DELETE = 'DOMAIN_DELETE';
export const DOMAIN_SET_DEFAULT = 'DOMAIN_SET_DEFAULT';
export const DOMAIN_APPLY = 'DOMAIN_APPLY';

// Shortener actions
export const SHORTENER_LIST = 'SHORTENER_LIST';
export const SHORTENER_SHOW = 'SHORTENER_SHOW';
export const SHORTENER_CREATE = 'SHORTENER_CREATE';
export const SHORTENER_UPDATE = 'SHORTENER_UPDATE';
export const SHORTENER_DELETE = 'SHORTENER_DELETE';
export const SHORTENER_SET_DEFAULT = 'SHORTENER_SET_DEFAULT';
export const SHORTENER_APPLY = 'SHORTENER_APPLY';
export const SHORTENER_LOG = 'SHORTENER_LOG';
export const SHORTENER_TEST = 'SHORTENER_TEST';

// Post actions (as in making a post not the request type)
export const POST_CREATE = 'POST_CREATE';
export const POST_CREATE_OLD = 'POST_CREATE_OLD';
export const POST_SHOW = 'POST_SHOW';
export const POST_UPLOAD = 'POST_UPLOAD';
export const POST_PREVIEW = 'POST_PREVIEW';
export const POST_VALIDATORS_LIST = 'POST_VALIDATORS_LIST';
export const POST_MEDIA_VALIDATION = 'POST_MEDIA_VALIDATION';
export const POST_MEDIA_GALLERY = 'POST_MEDIA_GALLERY';

// Queue Actions
export const QUEUE_LIST = 'QUEUE_LIST';
export const QUEUE_ORDER_UPDATE = 'QUEUE_ORDER_UPDATE';
export const QUEUE_DELETE = 'QUEUE_DELETE';
export const QUEUE_UPDATE = 'QUEUE_UPDATE';
export const QUEUE_CALENDAR_LIST = 'QUEUE_CALENDAR_LIST';
export const QUEUE_CALENDAR_DETAIL = 'QUEUE_CALENDAR_DETAIL';

// Everqueue actions
export const EVERQUEUE_LIST = 'EVERQUEUE_LIST';
export const EVERQUEUE_DELETE = 'EVERQUEUE_DELETE';
export const EVERQUEUE_UPDATE = 'EVERQUEUE_UPDATE';

// Subaccount actions
export const SUBACCOUNT_LIST = 'SUBACCOUNT_LIST';
export const SUBACCOUNT_SHOW = 'SUBACCOUNT_SHOW';
export const SUBACCOUNT_CREATE = 'SUBACCOUNT_CREATE';
export const SUBACCOUNT_UPDATE = 'SUBACCOUNT_UPDATE';
export const SUBACCOUNT_DELETE = 'SUBACCOUNT_DELETE';
export const SUBACCOUNT_DETACH = 'SUBACCOUNT_DETACH';

// Feed lookup actions
export const FEED_SEARCH = 'FEED_SEARCH';
export const FEED_SEARCH_RESET = 'FEED_SEARCH_RESET';
export const FEED_VALIDATE = 'FEED_VALIDATE';
export const FEED_VALIDATE_RESET = 'FEED_VALIDATE_RESET';

// Post Group actions
export const POSTGROUP_LIST = 'POSTGROUP_LIST';
export const POSTGROUP_SHOW = 'POSTGROUP_SHOW';
export const POSTGROUP_CREATE = 'POSTGROUP_CREATE';
export const POSTGROUP_UPDATE = 'POSTGROUP_UPDATE';
export const POSTGROUP_DELETE = 'POSTGROUP_DELETE';

// Notification actions
export const NOTIFICATIONS_LIST = 'NOTIFICATIONS_LIST';
export const NOTIFICATIONS_CLEAR = 'NOTIFICATIONS_CLEAR';

// Stats actions
export const STATS_FETCH_SOCIAL = 'STATS_FETCH_SOCIAL';
export const STATS_FETCH_SOCIAL_POSTS = 'STATS_FETCH_SOCIAL_POSTS';
export const STATS_FETCH_ROUTE = 'STATS_FETCH_ROUTE';
export const STATS_FETCH_ROUTE_POSTS = 'STATS_FETCH_ROUTE_POSTS';
export const STATS_FETCH_ALL = 'STATS_FETCH_ALL';
export const STATS_FETCH_ALL_POSTS = 'STATS_FETCH_ALL_POSTS';
export const STATS_FETCH_GEO = 'STATS_FETCH_GEO';

// Utility actions
export const UTILITIES_FETCH_COUNTRIES = 'UTILITIES_FETCH_COUNTRIES';
export const UTILITIES_FETCH_REGIONS = 'UTILITIES_FETCH_REGIONS';
export const UTILITIES_FETCH_FAVORITES = 'UTILITIES_FETCH_FAVORITES';
export const UTILITIES_URL_INFO_FETCH = 'UTILITIES_URL_INFO_FETCH';
export const UTILITIES_URL_INFO_CLEAR = 'UTILITIES_URL_INFO_CLEAR';
export const UTILITIES_FETCH_TIMEZONES = 'UTILITIES_FETCH_TIMEZONES';
export const UTILITIES_FILTER_STORE = 'UTILITIES_FILTER_STORE';
export const UTILITIES_CLEAR_FILTER = 'UTILITIES_CLEAR_FILTER';
export const UTILITIES_SORT_STORE = 'UTILITIES_SORT_STORE';
export const UTILITIES_FETCH_RELATED_HASHTAGS = 'UTILITIES_FETCH_RELATED_HASHTAGS';
export const UTILITIES_CLEAR_RELATED_HASHTAGS = 'UTILITIES_CLEAR_RELATED_HASHTAGS';

// Bulk actions
export const BULK_LIST = 'BULK_LIST';
export const BULK_DELETE = 'BULK_DELETE';
export const BULK_UPLOAD = 'BULK_UPLOAD';
export const BULK_BATCH = 'BULK_BATCH';
export const BULK_UPDATE = 'BULK_UPDATE';
export const BULK_POST = 'BULK_POST';
export const BULK_HINTS = 'BULK_HINTS';
export const BULK_RESULTS = 'BULK_RESULTS';
export const BULK_RESET = 'BULK_RESET';
export const BULK_STATUS = 'BULK_STATUS';

// Category actions
export const CATEGORY_LIST = 'CATEGORY_LIST';
export const CATEGORY_CREATE = 'CATEGORY_CREATE';
export const CATEGORY_UPDATE = 'CATEGORY_UPDATE';
export const CATEGORY_DELETE = 'CATEGORY_DELETE';

// Modal actions
export const MODAL_ADD = 'MODAL_ADD';
export const MODAL_CLOSE = 'MODAL_CLOSE';
export const MODAL_CLOSE_ALL = 'MODAL_CLOSE_ALL';
export const MODAL_CLOSE_OTHERS = 'MODAL_CLOSE_OTHERS';
export const MODAL_POP = 'MODAL_POP';

// Social Login Actions
export const LOGIN_CREATE = 'LOGIN_CREATE';
export const LOGIN_DELETE = 'LOGIN_DELETE';
export const LOGIN_LIST = 'LOGIN_LIST';

// Generic Connection Actions
export const CONNECTION_LIST = 'CONNECTION_LIST';
export const CONNECTION_SHOW = 'CONNECTION_SHOW';
export const CONNECTION_CREATE = 'CONNECTION_CREATE';
export const CONNECTION_UPDATE = 'CONNECTION_UPDATE';
export const CONNECTION_DELETE = 'CONNECTION_DELETE';
export const CONNECTION_REAUTH = 'CONNECTION_REAUTH';

// Message Types
export const MESSAGE_TYPE_INFO = 'MESSAGE_TYPE_INFO';
export const MESSAGE_TYPE_FLASH = 'MESSAGE_TYPE_FLASH';
